import RequestLocationPage from './views/RequestLocationPage.vue';

const routes = [
  {
    path: '/request-location/:token',
    name: 'request-location-public',
    component: RequestLocationPage,
    meta: {
      title: 'Fournir votre adresse - Rapidoo',
      requiresAuth: false, // Public route - no authentication required
      showHeader: false,
      showNav: false,
    },
  },
];

export default routes;
